import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { TOP_NAV_DATA_GA, TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import { Link } from '@/app/components/navigation/link';
import type { TopNavigationTransparentAppearanceType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
interface TopNavigationLogoProps {
  logo: ReactNode;
  appearance?: TopNavigationTransparentAppearanceType;
  isDesktopMenuOpen?: boolean;
  onMouseEnter?: () => void;
}
export const TopNavigationLogo = t0 => {
  const $ = _c(8);
  const {
    logo,
    appearance: t1,
    isDesktopMenuOpen: t2,
    onMouseEnter
  } = t0;
  const appearance = t1 === undefined ? "default" : t1;
  const isDesktopMenuOpen = t2 === undefined ? false : t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: TOP_NAV_DATA_TEST.logo
    });
    t4 = createDataGA({
      click: true,
      eventName: TOP_NAV_DATA_GA.topNavigation,
      text: TOP_NAV_DATA_GA.logo,
      url: "/"
    });
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  const t5 = appearance === "hero" && !isDesktopMenuOpen ? "text-white" : "text-red-500";
  let t6;
  if ($[2] !== t5) {
    t6 = cn("aspect-8-3 flex items-center outline-none", t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== logo || $[5] !== onMouseEnter || $[6] !== t6) {
    t7 = <Link href="/" {...t3} {...t4} className={t6} onMouseEnter={onMouseEnter}>{logo}</Link>;
    $[4] = logo;
    $[5] = onMouseEnter;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};